import { SlicePipe, JsonPipe, CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { BaseRules, TextValues } from './wisconsin-model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-wisconsin',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './wisconsin.component.html',
  styleUrl: './wisconsin.component.scss',
})
export class WisconsinComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('wisconsin', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('wisconsin', null);
    }
  }

  onSelect(selectionId: string, formControlName: string): void {
    if (selectionId === 'IndividualState_Split') {
      if (formControlName === 'UMLIMITEPEA_DropDown') {
        if (this.reactiveForm.get('UMLIMITEPEA_DropDown').valid) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('UMLimitsEPEA_LevelTwo_Radio');
        }
      }
    }
    if (selectionId === 'IndividualState_CombinedSingleLimit') {
      if (formControlName === 'UMLimitEA_DropDown') {
        if (this.reactiveForm.get('UMLimitEA_DropDown').valid) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('UMLimitsEPEA_LevelTwo_Radio');
        }
      }
    }
  }
}
